import actions from '../../actionTypes';

export default (orgUserRole) => {
  return {
    type: actions.SET_ORG_USER_ROLE,
    orgUserRole
  };
};



// WEBPACK FOOTER //
// ./src/reducers/organizations/actions/setOrgUserRole.js